var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    baseProfile: "full",
    xmlns: "http://www.w3.org/2000/svg",
    height: "4",
    width: "12",
    viewBox: "0 0 12 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-b1",
    d: "M9.999 3.01A1.046 1.046 0 1 1 9.998.917a1.046 1.046 0 0 1 .001 2.093zm-3.998 0A1.046 1.046 0 1 1 6 .917 1.046 1.046 0 0 1 6 3.01zm-4.048-.041A1.055 1.055 0 0 1 .906 1.906c0-.587.469-1.062 1.047-1.062S3 1.319 3 1.906c0 .587-.469 1.063-1.047 1.063z"
  }));
};